import { useTranslation } from 'react-i18next';

import Alert from '../../../../../../../components/Alert';
import { i18nNS } from '../../../../../../../i18n';
import ErrorsList, { ErrorsListProps } from '../../../../ErrorsList';

export interface ViewErrorsDialogProps extends Pick<ErrorsListProps, 'errors'> {
  open: boolean;
  onClose: () => void;
}

const ViewErrorsDialog = ({ open, onClose, errors }: ViewErrorsDialogProps) => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY]);

  return (
    <Alert open={open} onClose={onClose}>
      <Alert.Header>{t('errors', { ns: i18nNS.GLOSSARY })}</Alert.Header>
      <Alert.Body>
        <ErrorsList errors={errors} />
      </Alert.Body>
      <Alert.Footer>
        <Alert.Action variant="text">{t('okay', { ns: i18nNS.GLOSSARY })}</Alert.Action>
      </Alert.Footer>
    </Alert>
  );
};

export default ViewErrorsDialog;
